<template>
  <drag-modal :visible="$store.state.dislog.reason" @cancel="reset()" title='作废原因' width='564px'>
    <div class="twobox">
      <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="{span: 4}" :wrapper-col="{span: 20}">
        <a-form-model-item label="作废原因" prop='reason' :rules="{ required: true, message: '请填写作废原因',trigger: 'blur'}">
          <!-- <a-select show-search v-model='form.reason' placeholder="请填写作废原因" style="width: 100%" :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null" @search="handleSearch" @change="handleChange">
            <a-select-option v-for="d in data" :key="d.value">
              {{ d.text }}
            </a-select-option>
          </a-select> -->
          <a-auto-complete :data-source="data" style="width: 100%;" @search="handleSearch" @change="e=>form.reason=e">
            <a-textarea placeholder="请填写作废原因" v-model='form.reason' class="custom" style="height:120px;" />
          </a-auto-complete>

        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 16, offset: 6 }">
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='sub'>
            <a-button type="primary" style="width:148px;">
              提交
            </a-button>
          </a-popconfirm>
          <a-button style=" margin-left: 20px;width:148px;background:#B2C9E1;color:#fff;" @click="reset()">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </drag-modal>

</template>
<script>
import { delInvaild } from "@/server/api"
export default {
  name:'Reason',
  data() {
    return {
      form: {
        reason: ''
      },
      rules: {},
      data: []
    }
  },
  methods: {
    ss(e) {
      // console.log(e)
    },
    gtLetter() {
      return (JSON.parse(localStorage.getItem("letter")) || []).filter(ele => { return ele })
    },
    handleSearch(value) {
      this.data = !value ? [] : this.gtLetter().filter(ele => { return ele.indexOf(value) >= 0 });
    },
    sub() {
      delInvaild({ cause_id: this.$store.state.cause.id, reason: this.form.reason }).then(e => {
        let letter = this.gtLetter()
        if (letter.indexOf(this.form.reason) < 0) {
          letter.push(this.form.reason)
          localStorage.setItem("letter", JSON.stringify(letter))
        }
        this.$message.success({ content: '已提交审核', key: 'updatable' });
        setTimeout(e => {
          window.history.go(0)
        }, 500)
      })
    },
    reset() {
      this.$store.dispatch('openkey', { key: 'reason', by: false })
    },
  }
}
</script>